import classNames from 'classnames';

import { ProductDetailsDescriptionSkeleton } from '../ProductDetailsDescription';
import { ProductDetailsCharacteristicsSkeleton } from '../ProductDetailsCharacteristics';

import s from './ProductDetailsProperties.sss';

interface Props {
  className?: string,
}

export const ProductDetailsPropertiesSkeleton: React.FC<Props> = ({
  className,
}) => {
  return (
    <div className={classNames(s.root, className)}>
      <section className={s.description}>
        <ProductDetailsDescriptionSkeleton />
      </section>

      <section className={s.characteristics}>
        <ProductDetailsCharacteristicsSkeleton />
      </section>
    </div>
  );
};
